import axios from 'axios';
import { GET_AUDIO, GET_AUDIOS, AGGIUNGI_AUDIO, MODIFICA_AUDIO, ELIMINA_AUDIO, AUDIO_ERROR } from './types';
import { setAlert } from './alert';



export const getAudios = () => async dispatch => {
    try{
        const res = await axios.get('/api/audio/getAudios');
        dispatch({
            type: GET_AUDIOS,
            payload: res.data
        });
    }catch(err){
        dispatch({
            type: AUDIO_ERROR
        });
    }
}

export const getAudio = ({ idAudio }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ idAudio });
    try{
        const res = await axios.post('/api/audio/getAudio', body, config);
        dispatch({
            type: GET_AUDIO,
            payload: res.data
        });
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AUDIO_ERROR
        });
    }
};

export const aggiungiAudio = ({ titolo, codice, descrizione, link }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ titolo, codice, descrizione, link });
    try{
        const res = await axios.post('/api/audio/aggiungiAudio', body, config);
        dispatch({
            type: AGGIUNGI_AUDIO,
            payload: res.data
        });
        dispatch(setAlert("Audio aggiunto con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AUDIO_ERROR
        });
    }
};


export const modificaAudio = ({ idAudio, titolo, codice, descrizione, link }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ idAudio, titolo, codice, descrizione, link });
    try{
        const res = await axios.post('/api/audio/modificaAudio', body, config);
        dispatch({
            type: MODIFICA_AUDIO,
            payload: res.data
        });
        dispatch(setAlert("Audio modifcato con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AUDIO_ERROR
        });
    }
};

export const eliminaAudio = ({ idAudio }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ idAudio });
    try{
        const res = await axios.post('/api/audio/eliminaAudio', body, config);
        dispatch({
            type: ELIMINA_AUDIO,
            payload: res.data
        });
        dispatch(setAlert("Audio eliminato con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AUDIO_ERROR
        });
    }
};